import type {
  CategorySel,
  Creator,
  CreatorCategory,
  CreatorType,
} from '@/types';
import { pbFileUrl } from '@/utils/pb-file-url';

const CATEGORY_LABELS: Record<
  CreatorType,
  Partial<Record<CreatorCategory, string>>
> = {
  empresa: { 1: 'Librería', 2: 'Biblioteca', 3: 'Editorial' },
  persona: {
    1: 'Bookgramer',
    2: 'Con libros visibles',
    3: 'Persona interesante',
    4: 'Autor',
  },
};

const TYPE_LABEL: Record<CreatorType, string> = {
  empresa: 'Empresa',
  persona: 'Persona',
};

export function categoryLabel(type: CreatorType, n: CreatorCategory): string {
  return CATEGORY_LABELS[type]?.[n] ?? `Cat ${n}`;
}

export type CategoryOption = CategorySel & { value: string; label: string };

export function categoryOptions(): CategoryOption[] {
  const out: CategoryOption[] = [];
  (['empresa', 'persona'] as const).forEach((type) => {
    const labels = CATEGORY_LABELS[type];
    Object.keys(labels).forEach((k) => {
      const n = Number(k) as CreatorCategory;
      out.push({
        type,
        category: n,
        value: `${type}:${n}`,
        label: `${TYPE_LABEL[type]} · ${labels[n] ?? n}`,
      });
    });
  });
  return out;
}

export function parseCategoryValue(v: string): CategorySel | null {
  const [type, n] = v.split(':');
  if (type !== 'empresa' && type !== 'persona') return null;
  const cat = Number(n);
  if (!Number.isInteger(cat) || cat < 1 || cat > 4) return null;
  return { type, category: cat as CreatorCategory };
}

export function creatorPhotoUrl(creator: Creator): string {
  if (creator.photo) return pbFileUrl(creator, creator.photo);
  return creator.profile_photo ?? '';
}
